<template>
  <div class="page survey-home">
    <v-container class="text-center">
      <h1 class="text-h4 py-8">Rilevazione sul Trasporto merci su strada</h1>

      <v-card width="500" class="mx-auto pa-5" outlined rounded="lg">
        <v-card-text class="text-body-1 text-center">
          Targa automezzo oggetto della rilevazione
          <div class="text-h4 pt-1">{{ survey.vehicle_targa }}</div>
          <div class="mt-5">Periodo di rilevazione</div>
          <div class="pt-1">
            dal <strong>{{ startDate }}</strong> al <strong>{{ endDate }}</strong>
          </div>
        </v-card-text>
        <v-card-actions class="pt-8">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="handleClick" class="rounded-lg px-6" depressed>
            {{ isStarted ? `Continua` : `Inizia` }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

      <div class="py-3">
        Per ricevere assistenza scrivi a <a href="mailto:assistenza@istattms.it">assistenza@istattms.it</a>
      </div>
    </v-container>
  </div>
</template>

<script>
// Store
import { mapState, mapGetters } from 'vuex'

// Third-party libs
import firebase from 'firebase/app'
import { format, parse } from 'date-fns'
import { it } from 'date-fns/locale'

export default {
  computed: {
    ...mapState('survey', ['survey']),
    ...mapGetters('survey', ['isStarted', 'isSubmitted', 'isExpired']),
    startDate() {
      return this.survey?.start_date
        ? format(parse(this.survey?.start_date, 'yyyy-MM-dd', new Date()), 'd LLLL yyyy', { locale: it })
        : null
    },
    endDate() {
      return this.survey?.end_date
        ? format(parse(this.survey?.end_date, 'yyyy-MM-dd', new Date()), 'd LLLL yyyy', { locale: it })
        : null
    },
  },
  methods: {
    async handleClick() {
      if (!this.isStarted) {
        await this.$store.dispatch('surveys/update', {
          id: this.survey.id,
          data: {
            started_at: firebase.firestore.FieldValue.serverTimestamp(),
            last_page: this.survey.last_page ? this.survey.last_page : 0,
          },
        })
      }
      await this.$router.push({
        name: 'survey-user',
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
